import { API_TYPES } from "@src/appV2/api";
import { type QueryClient } from "@tanstack/react-query";

type QueryClientWithInvalidate = Pick<QueryClient, "invalidateQueries">;

export function getInterviewSettingsQueryKey(workplaceId: string) {
  return [API_TYPES.interviewSettings, workplaceId] as const;
}

export function invalidateInterviewSettingsQueries(
  queryClient: QueryClientWithInvalidate,
  workplaceId: string
) {
  return queryClient.invalidateQueries({
    queryKey: getInterviewSettingsQueryKey(workplaceId),
  });
}
